import { render, staticRenderFns } from "./ViewQuotes.vue?vue&type=template&id=7912f4d4&scoped=true&"
import script from "./ViewQuotes.vue?vue&type=script&lang=js&"
export * from "./ViewQuotes.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/view-quotes.css?vue&type=style&index=0&lang=css&"
import style1 from "./ViewQuotes.vue?vue&type=style&index=1&id=7912f4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7912f4d4",
  null
  
)

export default component.exports